export default __webpack_public_path__ + "static/woman-sorting-through-household-junk-319c4478bad40732f88ee437381cffd8.jpg";